


























import Vue from "vue";
import alpha from "color-alpha";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as imageLinks from "@/config/image-links";


/**
 * Character label component.
 */
@Component
export default class CharacterLabel extends Vue {
	// Injections
	imageLinks = imageLinks;
	classes = classes;

	@Prop()
	character!: any;

	@Prop({default: () => (character: any) => character.name})
	content!: (character: any) => string;

	@Prop()
	backgroundColor!: (character: any) => string;

	@Prop({default: () => (character: any) => null})
	rightIcon!: (character: any) => string;

	@Prop({default: () => (character: any) => null})
	rightIconColor!: (character: any) => string;

	@Prop({type: Boolean})
	isDragging!: boolean;

	@Prop({type: Boolean, default: false})
	isOutlinable!: boolean;

	handleDoubleClick() {
		this.$emit("on-dblclick", this.character);
	}

	handleContextMenu(ev: Event) {
		this.$emit("on-contextmenu", this.character, ev);
		return false;
	}

	baseColor() {
		if (this.backgroundColor) {
			return this.backgroundColor(this.character);
		}
		else {
			return classes[this.character.class].color;
		}
	}

	get color() {
		if (this.$vuetify.theme.dark && !this.isOutlinable) {
			return this.applyDarkAlpha(this.baseColor());
		}
		else {
			return this.baseColor();
		}
	}

	private applyDarkAlpha(color: string | null) {
		return alpha(color, 0.4);
	}
}
